<template>
	<page>
		<module>
			<view-list ref="view" work-type="1" selector :view-config="auth('b_aftersale_apply_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="售后申请单号">
							<c-input name="aftersale_apply_no"></c-input>
						</m-search-item>
                        <m-search-item label="售后类型">
                            <c-select name="aftersale_type" :options="afterSaleTypeDic"></c-select>
                        </m-search-item>
                        <m-search-item label="客户名称">
                            <c-input name="customer_name"></c-input>
                        </m-search-item>
                        <m-search-item label="客户联系人">
                            <c-input name="customer_contact"></c-input>
                        </m-search-item>
                        <m-search-item label="业务员">
                            <c-input name="salesman_name"></c-input>
                        </m-search-item>
                        <m-search-item label="意见处理单">
                            <c-input name="complaint_no"></c-input>
                        </m-search-item>
                        <m-search-item label="分配网点">
                            <c-select name="authorized_outlet_id" async @search="searchOutlet" :value-data="selectedOutlet"></c-select>
                        </m-search-item>
						<m-search-item label="状态">
                            <c-select name="order_transfer_status" :options="orderTransferStatusDic"  multiple></c-select>
						</m-search-item>
					</m-search>
				</template>

                <!--单据编号-->
                <template #aftersale_apply_no="{data}">
                    <c-link @click="globalDialog('aftersaleApplyDetail', {props: {id: data.id}})">{{data.aftersale_apply_no}}</c-link>
                    <c-state v-if="data.tags && data.tags.indexOf('测试')!=-1" dict="applyTagShortDic" tag value="测"></c-state>
                </template>
                <!--状态-->
                <template #order_transfer_status="{data}">
                    <c-state dict="orderTransferStatusDic" tag :value="data.order_transfer_status"></c-state>
                    <c-tooltip v-if="data.order_transfer_status == 2 && data.suspend_reason">
                        <span style="color: #ff4d4f; margin-left: 4px; cursor: pointer; font-weight: bold;">!</span>
                        <template #tip>
                            <p>{{data.suspend_reason}}</p>
                        </template>
                    </c-tooltip>
                </template>
                <!--服务类型-->
                <template #service_type_code="{data}">
                    <c-state dict="serviceTypeDic"  :value="data.service_type_code"></c-state>
                </template>
                <!--售后类型-->
                <template #aftersale_type_code="{data}">
                    <c-state dict="afterSaleTypeDic" :value="data.aftersale_type_code"></c-state>
                </template>
                <!--是否收费-->
                <template #is_charge_code="{data}">
                    <c-state dict="isChargeDic" :value="data.is_charge_code"></c-state>
                </template>
                <!--服务进度-->
                <template #service_progress="{data}">
                    <c-steps v-if="data.service_progress" :steps="serviceProgressDic" :active="data.service_progress-1" gap="50" style="padding: 0;"></c-steps>
                </template>
                <!--金额-->
                <template #estimated_fee="{data}">
                    ￥{{data.estimated_fee}}
                </template>

				<template #operate="{data}">
                    <c-button v-if="auth('b_aftersale_apply_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>

				</template>
                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_aftersale_apply_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
				<c-table-column
					type="button"
					label="操作"
					width="250"
					button-limit="4"
				>
					<template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('aftersaleApplyDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_apply_tag')" icon="tf-edit" @click="openApplyTagsDialog(data)">标签</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_apply_authorize') && !data.order_id" :disabled="data.is_suspended == 1" icon="tf-delete" @click="authorizeAftersaleApply(data)">分配网点</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_apply_authorize') && data.order_id" :disabled="true" icon="tf-delete" @click="authorizeAftersaleApply(data)">分配网点</c-table-button>
						<c-table-button v-if="auth('b_aftersale_apply_transfer') && !data.order_id"  icon="tf-reset-password" :disabled="(data.order_transfer_status == 1 && data.service_progress > 1) || data.is_suspended == 1" @click="addAftersaleOrder(data)">转售后工单</c-table-button>
						<c-table-button v-if="auth('b_aftersale_apply_transfer') && data.order_id"  icon="tf-reset-password" :disabled="(data.order_transfer_status == 1 && data.service_progress > 1) || data.is_suspended == 1" @click="editAftersaleOrder(data)">转售后工单</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_apply_suspend') && !data.order_id && data.is_suspended != 1" icon="tf-stop" @click="suspendApply(data)">挂起</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_apply_suspend') && data.is_suspended == 1" icon="tf-start" @click="resumeApply(data)">恢复</c-table-button>
					</template>
				</c-table-column>
			</view-list>

            <!--修改预约时间-->
            <c-dialog ref="applyTagsDialog" title="申请单标签" width="500" height="200" @resolve="applyTagsHandle">
                <c-form ref="applyTagsForm" vertical unit-width="100%">
                    <c-form-item label="售后申请单号">
                        <c-input name="id" type="hidden"></c-input>
                        <c-input name="aftersale_apply_no" disabled></c-input>
                    </c-form-item>
                    <c-form-item label="标签">
                        <c-select name="tags" v-model="applyTags" :options="applyTagDic" :rows="3"  multiple></c-select>
                    </c-form-item>
                </c-form>
            </c-dialog>
            <c-dialog ref="suspendDialog" title="挂起申请单" width="500" height="200" @resolve="suspendHandle">
                <c-form ref="suspendForm" vertical unit-width="100%">
                    <c-form-item label="售后申请单号">
                        <c-input name="id" type="hidden"></c-input>
                        <c-input name="aftersale_apply_no" disabled></c-input>
                    </c-form-item>
                    <c-form-item label="备注">
                        <c-input name="suspend_reason" type="textarea" :rows="3" placeholder="请输入挂起备注"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
            <c-dialog ref="authorizeDialog" title="分配网点" width="500" height="200" @resolve="authorizeHandle">
                <c-form ref="authorizeForm" vertical unit-width="100%">
                    <c-form-item label="售后申请单号">
                        <c-input name="id" type="hidden"></c-input>
                        <c-input name="aftersale_apply_no" disabled></c-input>
                    </c-form-item>
                    <c-form-item label="分配至网点">
                        <c-select name="authorized_outlet_id" async @search="searchOutlet" :value-data="selectedOutlet" :disable-options="disableOutletSelect">
                            <template #option="{data, selected, disabled}">
                                <select-option
                                        :name="data.name"
                                        :info="[
                                `负责人： ${data.data.principal_user_name || '-'}`
                            ]"
                                        :selected="selected"
                                        :disabled="disabled"
                                ></select-option>
                            </template>
                        </c-select>

                    </c-form-item>
                </c-form>
            </c-dialog>
		</module>

	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		computed: {
			// 获取dictName选项数据
			...mapState(['orderTransferStatusDic','afterSaleTypeDic','serviceTypeDic','applyTagDic','applyTagShortDic']),
		},

		data() {
			return {
				defaultSearchData: {

				},
                serviceProgressDic:[ {
                    name: '创建工单',
                }, {
                    name: '指派工单',
                }, {
                    name: '工单确认',
                }, {
                    name: '执行工单',
                }, {
                    name: '工单完结',
                }, {
                    name: '客户验收',
                }],
                selectedOutlet:[],
                disableOutletSelect: [],
                applyTags:[],
			}
		},

		methods: {
            updateMethod(){
               this.$refs.view.$refs.list.update();
               this.$refs.view.updateTabTotal();
            },
            addAftersaleOrder(data) {
                this.globalDialog('aftersaleOrderEdit', {props: {source: data.id}}, this.updateMethod);
            },
            editAftersaleOrder(data) {
                this.globalDialog('aftersaleOrderEdit', {props: {id: data.order_id}}, this.updateMethod);
            },
            openApplyTagsDialog(data){
                this.applyTags = [];
                if(data.tags){
                    this.applyTags = data.tags.split(',');
                }
                this.$refs.applyTagsForm.clear();
                this.$refs.applyTagsForm.set({
                    id: data.id,
                    aftersale_apply_no: data.aftersale_apply_no,
                })
                this.$refs.applyTagsDialog.open();
            },
            applyTagsHandle(){
                stop();
                this.$refs.applyTagsForm.submit({
                    url: '/aftersale/apply/tags',
                    dataFormatter: data => {
                        return {
                            id: data.id,
                            tags: this.applyTags.join(',')
                        }
                    },
                    success: (data, res) => {
                        this.$message({
                            message: '修改标签成功',  // 提示内容,
                            type: 'success'
                        });
                        this.updateMethod();
                    }
                });
            },
            /*******搜索网点*****************/
            searchOutlet(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'AFTERSALE_OUTLET',
                        keyword:keyword
                    },
                    success:data => {
                        this.disableOutletSelect = data.reduce((acc, item) => {
                            if (!item.data.principal_user_id) {
                                acc.push(item.value);
                            }
                            return acc;
                        }, []);
                        resolve(data);
                    }
                })
            },
            authorizeAftersaleApply(data){
                this.$refs.authorizeForm.clear();
                if(data.authorized_outlet_id){
                    this.selectedOutlet = [
                        {
                            name: data.authorized_outlet_name,
                            value: data.authorized_outlet_id
                        }
                    ]
                }
                this.$refs.authorizeForm.set({
                    id: data.id,
                    aftersale_apply_no: data.aftersale_apply_no + '-'+data.customer_name,
                })
                this.$refs.authorizeDialog.open();
            },
            authorizeHandle(){
                stop();
                this.$refs.authorizeForm.submit({
                    url: '/aftersale/apply/authorized_outlet',
                    dataFormatter: data => {
                        return {
                            id: data.id,
                            authorized_outlet_id: data.authorized_outlet_id
                        }
                    },
                    success: (data, res) => {
                        this.$message({
                            message: '分配网点成功',
                            type: 'success'
                        });
                        this.updateMethod();
                    }
                });
            },
            /******挂起售后申请单************/
            suspendApply(data){
                this.$refs.suspendForm.clear();
                this.$refs.suspendForm.set({
                    id: data.id,
                    aftersale_apply_no: data.aftersale_apply_no,
                })
                this.$refs.suspendDialog.open();
            },
            suspendHandle(){
                stop();
                this.$refs.suspendForm.submit({
                    url: '/aftersale/apply/suspend',
                    dataFormatter: data => {
                        return {
                            id: data.id,
                            suspend_reason: data.suspend_reason
                        }
                    },
                    success: (data, res) => {
                        this.$message({
                            message:'挂起成功',
                            type: 'success'
                        });
                        this.updateMethod();
                    }
                });
            },
            /******恢复售后申请单************/
            resumeApply(data){
                this.$confirm({
                    message:'确认恢复售后申请单【'+data.aftersale_apply_no+'】？',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/aftersale/apply/resume',
                            data: {id: data.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    message:'恢复成功',
                                    type: 'success'
                                });
                                this.updateMethod();
                            }
                        });
                    },
                    cancel: () => {},
                });
            },
		}
	}
</script>

<style lang="stylus" scoped>
</style>